import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CustomCart } from '@cart/const';

@Component({
  selector: 'sd-order-summary',
  templateUrl: './order-summary.component.html',
  styleUrls: ['./order-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdCustomOrderSummaryComponent {
  @Input() cart: CustomCart;
}
